import _toConsumableArray from "/builder/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/builder/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builder/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builder/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builder/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _applyDecoratedDescriptor from '@babel/runtime/helpers/esm/applyDecoratedDescriptor';
import { extension, command, keyBinding, NamedShortcut, MarkExtension, ExtensionTag, isElementDomNode, isString, markInputRule, toggleMark, getTextSelection } from '@remirror/core';
import { ExtensionBoldMessages } from '@remirror/messages';

var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2;

var toggleBoldOptions = {
  icon: 'bold',
  label: function label(_ref) {
    var t = _ref.t;
    return t(ExtensionBoldMessages.LABEL);
  },
  description: function description(_ref2) {
    var t = _ref2.t;
    return t(ExtensionBoldMessages.DESCRIPTION);
  }
};
var BoldExtension = (_dec = extension({
  defaultOptions: {
    weight: undefined
  },
  staticKeys: ['weight']
}), _dec2 = command(toggleBoldOptions), _dec3 = command(), _dec4 = command(), _dec5 = keyBinding({
  shortcut: NamedShortcut.Bold,
  command: 'toggleBold'
}), _dec(_class = (_class2 = /*#__PURE__*/function (_MarkExtension) {
  _inherits(BoldExtension, _MarkExtension);

  var _super = _createSuper(BoldExtension);

  function BoldExtension() {
    _classCallCheck(this, BoldExtension);

    return _super.apply(this, arguments);
  }

  _createClass(BoldExtension, [{
    key: "name",
    get: function get() {
      return 'bold';
    }
  }, {
    key: "createTags",
    value: function createTags() {
      return [ExtensionTag.FormattingMark, ExtensionTag.FontStyle];
    }
  }, {
    key: "createMarkSpec",
    value: function createMarkSpec(extra, override) {
      var _this = this;

      var _override$parseDOM;

      return _objectSpread(_objectSpread({}, override), {}, {
        attrs: extra.defaults(),
        parseDOM: [{
          tag: 'strong',
          getAttrs: extra.parse
        }, // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
          tag: 'b',
          getAttrs: function getAttrs(node) {
            return isElementDomNode(node) && node.style.fontWeight !== 'normal' ? extra.parse(node) : false;
          }
        }, {
          style: 'font-weight',
          getAttrs: function getAttrs(node) {
            return isString(node) && /^(bold(er)?|[5-9]\d{2,})$/.test(node) ? null : false;
          }
        }].concat(_toConsumableArray((_override$parseDOM = override.parseDOM) !== null && _override$parseDOM !== void 0 ? _override$parseDOM : [])),
        toDOM: function toDOM(node) {
          var weight = _this.options.weight;

          if (weight) {
            return ['strong', {
              'font-weight': weight.toString()
            }, 0];
          }

          return ['strong', extra.dom(node), 0];
        }
      });
    }
  }, {
    key: "createInputRules",
    value: function createInputRules() {
      return [markInputRule({
        regexp: /(?:\*\*|__)([^*_]+)(?:\*\*|__)$/,
        type: this.type,
        ignoreWhitespace: true
      })];
    }
    /**
     * Toggle the bold styling on and off. Remove the formatting if any
     * matching bold formatting within the selection or provided range.
     */

  }, {
    key: "toggleBold",
    value: function toggleBold(selection) {
      return toggleMark({
        type: this.type,
        selection: selection
      });
    }
    /**
     * Set the bold formatting for the provided range.
     */

  }, {
    key: "setBold",
    value: function setBold(selection) {
      var _this2 = this;

      return function (_ref3) {
        var tr = _ref3.tr,
            dispatch = _ref3.dispatch;

        var _getTextSelection = getTextSelection(selection !== null && selection !== void 0 ? selection : tr.selection, tr.doc),
            from = _getTextSelection.from,
            to = _getTextSelection.to;

        dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr.addMark(from, to, _this2.type.create()));
        return true;
      };
    }
    /**
     * Remove the bold formatting from the provided range.
     */

  }, {
    key: "removeBold",
    value: function removeBold(selection) {
      var _this3 = this;

      return function (_ref4) {
        var tr = _ref4.tr,
            dispatch = _ref4.dispatch;

        var _getTextSelection2 = getTextSelection(selection !== null && selection !== void 0 ? selection : tr.selection, tr.doc),
            from = _getTextSelection2.from,
            to = _getTextSelection2.to;

        if (!tr.doc.rangeHasMark(from, to, _this3.type)) {
          return false;
        }

        dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr.removeMark(from, to, _this3.type));
        return true;
      };
    }
    /**
     * Attach the keyboard shortcut for making text bold to this mark and also to
     * the `toggleBold` command.
     */

  }, {
    key: "shortcut",
    value: function shortcut(props) {
      return this.toggleBold()(props);
    }
  }]);

  return BoldExtension;
}(MarkExtension), (_applyDecoratedDescriptor(_class2.prototype, "toggleBold", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleBold"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setBold", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "setBold"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "removeBold", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "removeBold"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "shortcut", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "shortcut"), _class2.prototype)), _class2)) || _class);
export { BoldExtension };